document.addEventListener("DOMContentLoaded", () => {
  
  const has = (k) => typeof window[k] !== "undefined";

  if (has("gsap") && has("ScrollTrigger")) {
    gsap.registerPlugin(ScrollTrigger);
  } else {
    console.warn("[main.js] GSAP/ScrollTrigger missing");
    return; 
  }


  const safeScrollOut = has("ScrollOut") ? ScrollOut : null;
  const safeLenis = has("Lenis") ? Lenis : null;

  const winH = window.innerHeight;
  const winW = window.innerWidth;
/* FIX: Force GSAP to own transform */
gsap.set(".LogoMainWrap", {
  xPercent: -50,
  yPercent: -50
});

  if (safeScrollOut) {
    ScrollOut({
      once: true,
    });
  }

  if (safeLenis) {
    const lenis = new Lenis({
      duration: 2,
    });

    lenis.on("scroll", (e) => {
      ScrollTrigger.update();
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  
  function AboutAnim() {
    const section = document.querySelector(".SectionWrapper");
    if (!section) {
      console.warn("AboutAnim: .SectionWrapper not found");
      return;
    }

    const AboutAnimate = gsap
      .timeline()
      .to(
        ".BannerDiv",
        {
          y: "-140%",
          duration:2,
        },
        "1st"
      )
      .to(
        ".LineDiv",
        {
          height: "100%",
        },
        "2nd"
      )
      .to(
        ".BoxWrap2",
        {
          x: winW > 1200 ? "140px" : "85px",
        },
        "2nd"
      );

    if (winW > 991) {
      AboutAnimate.to(
        ".BoxWrap1 .LineSvg",
        {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        },
        "3rd"
      )
        .to(
          ".BoxWrap1 .BxTitle,.BoxWrap1 .LogoIcon",
          {
            opacity: 1,
          },
          "4th"
        )
        .to(
          ".BoxWrap2 .LineSvg",
          {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          },
          "5th"
        )
        .to(
          ".BoxWrap2 .BxTitle,.BoxWrap2 .LogoIcon",
          {
            opacity: 1,
          },
          "6th"
        )
        .to(
          ".BoxWrap3 .LineSvg",
          {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          },
          "7th"
        )
        .to(
          ".BoxWrap3 .BxTitle,.BoxWrap3 .LogoIcon",
          {
            opacity: 1,
          },
          "8th"
        );
    } else {
      AboutAnimate.to(
        ".MobBx1 .LineMobImg",
        {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        },
        "3rd"
      )
        .to(
          ".MobBx2 .LineMobImg",
          {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          },
          "4th"
        )
        .to(
          ".MobBx3 .LineMobImg",
          {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          },
          "5th"
        );
    }

    AboutAnimate.to(
      ".ProductsDiv",
      {
        y: winW > 1200 ? "-100%" : " ",
        duration: 1,
      },
      "9th"
    );

    ScrollTrigger.create({
      trigger: ".SectionWrapper",
      start: "top top",
      end: "+=" + winH * 2,
      pin: true,
      scrub: true,
      markers: false,
      animation: AboutAnimate,
    });
  }


  function SimplifiedAnim() {
    const hero = document.querySelector(".SimplifiedSec");
    const titleEl = document.querySelector(".HeadBx .Title");
    const overlay = document.querySelector(".HeadBx .TitleOverlay");
    const imgWrap = document.querySelector(".SimplifiedImg");
    const SimplifiedDiv = document.querySelector(".SimplifiedDiv");

    if (!hero || !titleEl || !overlay || !imgWrap || !SimplifiedDiv) {
      console.warn("SimplifiedAnim: missing required DOM elements");
      console.log("Found elements:", {
        hero: !!hero,
        titleEl: !!titleEl,
        overlay: !!overlay,
        imgWrap: !!imgWrap,
        SimplifiedDiv: !!SimplifiedDiv
      });
      return;
    }

    const mobTranslate = SimplifiedDiv.offsetHeight - winH + 115;
    console.log("SimplifiedAnim initialized", { winW, winH, mobTranslate });

    function updateMask() {
      const tr = titleEl.getBoundingClientRect();
      const ir = imgWrap.getBoundingClientRect();

      const titleH = tr.height;
      const overlap = Math.min(tr.bottom, ir.bottom) - Math.max(tr.top, ir.top);
      const clamped = Math.max(0, Math.min(overlap, titleH));
      const ratio = titleH === 0 ? 0 : clamped / titleH;

      const topInset = (1 - ratio) * 100;
      const insetValue = `inset(${topInset}% 0 0 0)`;
      overlay.style.clipPath = insetValue;
      overlay.style.webkitClipPath = insetValue;
    }

    const SimplifiedAnimate = gsap.timeline({
      defaults: { ease: "none" },
      scrollTrigger: {
        trigger: ".SimplifiedSec",
        start: "top top",
        end: "+=" + winH * 2,
        pin: true,
        scrub: true,
        markers: false,
        onUpdate: updateMask,
        onRefresh: updateMask,
      },
    });

    SimplifiedAnimate.to(
      ".LeftSphere, .RightSphere",
      { opacity: 1, duration: 0.1 },
      "1st"
    )
    
      .to(".LeftSphere", { x: "-100px", opacity: 0 }, "2nd")
      .to(".RightSphere", { x: "100px", opacity: 0 }, "2nd")
      .to(".Circle", { opacity: 0 }, "2nd")
      .to(".LogoDiv", { opacity: 1 }, "2nd")
      .to(".Ring1, .Ring3", { x: "0px" }, "2nd")
      .to(".LogoMainWrap", { y: "-100vh" }, "3rd");

    if (winW < 768) {
      SimplifiedAnimate.to(
        ".SimplifiedDiv",
        {
          y: -1 * mobTranslate + "px",
        },
        "3rd"
      );
    }

    SimplifiedAnimate.fromTo(
      imgWrap,
      { yPercent: 0 },
      { yPercent: -100 },
      "3rd"
    );

    window.addEventListener("resize", () => ScrollTrigger.refresh());
  }

  
  AboutAnim();
  
  if (winW > 991) {
    SimplifiedAnim();
  }

 
  if (has("Swiper")) {
    var ProductSwiper = new Swiper(".ProductSwiper", {
      slidesPerView: "auto",
      spaceBetween: 20,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: "#NextArrow",
        prevEl: "#PrevArrow",
      },
      loop: true,
      breakpoints: {
        992: {},
        768: {},
      },
    });

    var BlogSwiper = new Swiper(".BlogSwiper", {
      slidesPerView: "auto",
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: "#NextArrow",
        prevEl: "#PrevArrow",
      },
      loop: true,
      breakpoints: {
        768: {
          spaceBetween: 40,
        },
      },
    });
  }
});


  function secretAnimation() {
    const winH = window.innerHeight;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.secretDesktop',
        start: '-61px top',
        end: `+=${winH} / 0.6`,
        scrub: true,
        pin: true,
        markers: false,
      },
    });

    tl.to('.box2', { y: '0%' });
  }

  // function inspiredAction() {
  //   const tl = gsap.timeline();

  //   tl.to(".pinkImgBox", { x: "0%", duration: 1, ease: "linear" }, "0")
  //     .to(".dropImgBox", { x: "0%", duration: 1, ease: "linear" }, "0")
  //     .to(
  //       ".pinkContentBox",
  //       { right: "unset", left: "40px", duration: 1, ease: "linear" },
  //       "0"
  //     )
  //     .to(
  //       ".imgContentBox",
  //       { left: "unset", right: "40px", duration: 1, ease: "linear" },
  //       "0"
  //     );

  // }

  function inspiredAction() {
    const tl = gsap.timeline();

    tl.to('.pinkImgBox', { x: '0%', duration: 1, ease: 'linear' }, '0')
      .to('.dropImgBox', { x: '0%', duration: 1, ease: 'linear' }, '0')
      .to(
        '.pinkContentBox',
        {
          x: 0,
          // right: "unset",
          // left: "var(--container_left_space)",
          duration: 1,
          ease: 'linear',
        },
        '0'
      )
      .to(
        '.imgContentBox',
        {
          x: 0,
          // left: "unset",
          // right: "var(--container_left_space)",
          duration: 1,
          ease: 'linear',
        },
        '0'
      );
  }

  const section = document.querySelector('.inspiredSection');
  if(section){
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
            inspiredAction();
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: [0, 0.4, 1],
      }
    );

    observer.observe(section);
  }
  function lenis() {
    const lenis = new Lenis({
      duration: 2,
    });

    lenis.on('scroll', (e) => {});

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  if (window.innerWidth > 767) {
    secretAnimation();
  }

  lenis();
